<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center" style="height: 80vh;">
      <v-col cols="12" sm="8">
        <v-card class="mx-auto" max-width="600" elevation="0">

          <v-card-text class="text-center">
            <v-icon color="red" size="60" light>mdi-instagram</v-icon>
          </v-card-text>

          <v-card-text class="headline font-weight-bold text-center black--text my-0 py-0">{{msg.title || 'Este usuario no se encuentra.'}}</v-card-text>

          <v-card-text class="text-center  my-0 py-0">{{ msg.text || 'Es posible que el nick que has introducido sea incorrecto.' }}</v-card-text>

          <v-card-text v-if="nickName" class="text-center red--text  my-0 py-0" style="text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">@{{ nickName  }}</v-card-text>

          <v-card-text class="text-center">
              <v-btn @click.stop="$emit('resetear')" depressed color="black" dark>{{ msg.btnText || 'Intentar de nuevo' }}</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ErrorPage",
  props: {
    nickName: {
      type: String,
      default: null
    },
    msg: {
      type: Object,
      default: () => {
        return {
          title: "Este usuario no se encuentra.",
          text: "Es posible que el nick que has introducido sea incorrecto.",
          btnText: "Intentar de nuevo"
        }
      }
    }
  },

  data: () => ({
    //
  })
};
</script>